"use client";

import { PortfolioEstateSelectionPanel } from "@/components/portfolio/portfolio-page/PortfolioEstateSelectionPanel";
import { PortfolioTopHintWindow } from "@/components/portfolio/portfolio-page/PortfolioTopHintWindow";
import SelectedEstateCard from "@/components/portfolio/SelectedEstateCard";
import type { ClientEstate } from "@/types";
import { useHintWindowPreference } from "@/hooks/useHintWindowPreference";
import { ReactNode } from "react";

type PortfolioPageOverviewCardProps = {
  estateCount: number;
  estateCountLabel: string;
  activeViewLabel: string;
  activeViewDescription: string;
  isLoading: boolean;
  estates: ClientEstate[];
  selectedEstateId: number | null;
  currentEstateValue: number;
  portfolioEstimatedValue: number | null;
  onCreateEstate: () => void;
  createActionLabel?: string;
  onSelectEstate: (estate: ClientEstate | null) => void;
  emptyContent?: ReactNode;
};

export function PortfolioPageOverviewCard({
  estateCount,
  estateCountLabel,
  activeViewLabel,
  activeViewDescription,
  isLoading,
  estates,
  selectedEstateId,
  currentEstateValue,
  portfolioEstimatedValue,
  onCreateEstate,
  createActionLabel,
  onSelectEstate,
  emptyContent,
}: PortfolioPageOverviewCardProps) {
  const { isOpen: isHintOpen, toggle: toggleHint } =
    useHintWindowPreference("portfolioOverview");

  return (
    <div className="space-y-4">
      <PortfolioTopHintWindow
        estateCount={estateCount}
        activeViewLabel={activeViewLabel}
        activeViewDescription={activeViewDescription}
        isOpen={isHintOpen}
        onToggle={toggleHint}
      />

      <div
        className={estates.length > 0 ? "app-section-card w-full" : undefined}
      >
        <PortfolioEstateSelectionPanel
          estates={estates}
          estateCountLabel={estateCountLabel}
          isLoading={isLoading}
          selectedEstateId={selectedEstateId}
          currentEstateValue={currentEstateValue}
          portfolioEstimatedValue={portfolioEstimatedValue}
          embedded={estates.length > 0}
          onSelectEstate={onSelectEstate}
          onCreateEstate={onCreateEstate}
          createActionLabel={createActionLabel}
          emptyContent={emptyContent}
        />
        {estates.length > 0 ? <SelectedEstateCard embedded /> : null}
      </div>
    </div>
  );
}
